export const faqItems = [
  {
    id: 'faq-1',
    question: '吃瓜网站是什么？',
    answer: '吃瓜网站是一个专注于娱乐八卦和热门事件视频聚合的中文内容平台。我们每日收集整理全网最新最热的吃瓜视频、网红爆料和娱乐圈动态，让用户一站式浏览所有精彩"瓜"内容，不用再东奔西跑到处找。',
  },
  {
    id: 'faq-2',
    question: '吃瓜视频的更新频率是怎样的？',
    answer: '我们保持每日更新节奏，编辑团队 7×24 小时跟踪热点动态。每当有新的网红爆料、娱乐圈大事件或社交媒体热议话题，我们会在第一时间整理成视频合集推送到首页，确保你永远不会错过任何一个"瓜"。',
  },
  {
    id: 'faq-3',
    question: '如何快速找到自己感兴趣的吃瓜内容？',
    answer: '首页设有多个浏览入口：你可以通过「热搜榜单」查看当前最火的内容排名，通过「视频合集」按分类浏览，通过「热门话题」标签快速定位感兴趣的话题方向，也可以直接搜索关键词找到相关吃瓜视频。',
  },
  {
    id: 'faq-4',
    question: '网站上的视频内容来源可靠吗？',
    answer: '我们严格筛选内容来源，所有视频均来自公开的社交媒体平台和正规视频网站，并标注原始出处。编辑团队会对重要爆料内容进行多方核实后才推送，确保用户看到的吃瓜内容真实可信。',
  },
  {
    id: 'faq-5',
    question: '可以在手机上浏览吃瓜网站吗？',
    answer: '当然可以！吃瓜网站采用响应式设计，完美适配手机、平板和电脑等各种设备。无论你在通勤路上还是在家中，打开浏览器就能随时随地畅享吃瓜乐趣。我们还提供了移动端快捷入口，体验更流畅。',
  },
  {
    id: 'faq-6',
    question: '如何向吃瓜网站投稿或提供爆料线索？',
    answer: '欢迎通过首页的「联系我们」模块提交你的投稿或爆料线索。我们的编辑团队会在收到信息后尽快审核，优质内容将有机会被收录到首页推荐位展示。投稿时请尽量提供详细信息和相关素材链接。',
  },
];

export const carouselItems = [
  {
    id: 'carousel-1',
    title: '网红最新爆料合集',
    description: '整理近期社交媒体上最受关注的网红爆料事件，从直播翻车到私下恋情曝光，一网打尽各类网红圈最新瓜料。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20abstract%20illustration%20of%20social%20media%20influencers%20and%20trending%20topics%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20digital%20art%20style%2C%20modern%20clean%20composition%20with%20geometric%20elements%2C%20content%20creator%20aesthetic%2C%20vibrant%20yet%20refined&width=600&height=400&seq=carousel-01&orientation=landscape',
    tag: '网红爆料',
  },
  {
    id: 'carousel-2',
    title: '娱乐圈热点追踪',
    description: '明星动态实时追踪，从影视综艺到私生活传闻，深度梳理娱乐圈最热门的话题事件和发展脉络。',
    image: 'https://readdy.ai/api/search-image?query=An%20artistic%20abstract%20depiction%20of%20entertainment%20industry%20celebrities%20and%20spotlight%20themes%2C%20warm%20coral%20and%20gold%20tones%2C%20modern%20digital%20illustration%20style%2C%20elegant%20composition%20with%20soft%20geometric%20shapes&width=600&height=400&seq=carousel-02&orientation=landscape',
    tag: '娱乐圈',
  },
  {
    id: 'carousel-3',
    title: '热门综艺名场面',
    description: '各大热门综艺节目中的经典名场面回顾与盘点，从搞笑片段到争议瞬间，综艺吃瓜一网打尽。',
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20abstract%20illustration%20of%20variety%20show%20entertainment%20scenes%2C%20warm%20terracotta%20and%20amber%20color%20scheme%2C%20digital%20art%20aesthetic%2C%20dynamic%20composition%20with%20playful%20geometric%20patterns&width=600&height=400&seq=carousel-03&orientation=landscape',
    tag: '综艺盘点',
  },
  {
    id: 'carousel-4',
    title: '社交媒体热议事件',
    description: '微博、抖音、小红书等平台上的爆款话题深度分析，还原事件全貌，让你了解热搜背后的完整故事。',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20digital%20illustration%20of%20social%20media%20buzz%20and%20trending%20discussions%2C%20warm%20coral%20and%20soft%20gold%20colors%2C%20modern%20minimalist%20style%2C%20layered%20geometric%20elements%20representing%20online%20conversations&width=600&height=400&seq=carousel-04&orientation=landscape',
    tag: '社交热议',
  },
  {
    id: 'carousel-5',
    title: '经典吃瓜事件回顾',
    description: '盘点那些曾经轰动全网的经典吃瓜事件，回顾事件的来龙去脉和后续发展，新老瓜友都能一次看过瘾。',
    image: 'https://readdy.ai/api/search-image?query=A%20retro%20inspired%20abstract%20illustration%20of%20classic%20internet%20moments%20and%20viral%20events%2C%20warm%20amber%20and%20terracotta%20palette%2C%20digital%20art%20with%20nostalgic%20geometric%20patterns%2C%20elegant%20composition&width=600&height=400&seq=carousel-05&orientation=landscape',
    tag: '经典回顾',
  },
];

export const indexItems = [
  {
    id: 'idx-1', title: '网红翻车现场', count: 128, icon: 'ri-alert-line',
  },
  {
    id: 'idx-2', title: '明星恋情爆料', count: 96, icon: 'ri-heart-line',
  },
  {
    id: 'idx-3', title: '综艺争议名场面', count: 87, icon: 'ri-tv-line',
  },
  {
    id: 'idx-4', title: '直播精彩片段', count: 156, icon: 'ri-live-line',
  },
  {
    id: 'idx-5', title: '社会热点吃瓜', count: 112, icon: 'ri-fire-line',
  },
  {
    id: 'idx-6', title: '时尚圈八卦', count: 74, icon: 'ri-shirt-line',
  },
  {
    id: 'idx-7', title: '体育圈趣闻', count: 63, icon: 'ri-basketball-line',
  },
  {
    id: 'idx-8', title: '科技圈大事件', count: 55, icon: 'ri-smartphone-line',
  },
  {
    id: 'idx-9', title: '年度吃瓜盘点', count: 42, icon: 'ri-trophy-line',
  },
];

export const commentItems = [
  {
    id: 'cmt-1',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20avatar%20portrait%20in%20warm%20coral%20tones%2C%20digital%20art%20style%2C%20simple%20clean%20background%2C%20modern%20aesthetic&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '吃瓜群众小王',
    time: '2小时前',
    content: '每天必刷吃瓜网站，真的太上头了！更新速度比微博还快，而且整理得很清楚，不用到处翻来翻去找完整版了。',
    likes: 328,
  },
  {
    id: 'cmt-2',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20avatar%20portrait%20in%20warm%20amber%20tones%2C%20digital%20art%20style%2C%20simple%20clean%20background%2C%20modern%20aesthetic&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '八卦小能手',
    time: '5小时前',
    content: '这个网站是同事推荐给我的，现在已经成为我们办公室的每日必聊话题来源了。每次有大瓜出来，首页就能看到最全的整理。',
    likes: 256,
  },
  {
    id: 'cmt-3',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20avatar%20portrait%20in%20warm%20terracotta%20tones%2C%20digital%20art%20style%2C%20simple%20clean%20background%2C%20modern%20aesthetic&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '深夜冲浪选手',
    time: '8小时前',
    content: '凌晨三点还在刷吃瓜视频的请举手！这个网站的「经典回顾」栏目绝了，好多以前没吃全的瓜现在终于补上了。',
    likes: 189,
  },
  {
    id: 'cmt-4',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20avatar%20portrait%20in%20warm%20rose%20tones%2C%20digital%20art%20style%2C%20simple%20clean%20background%2C%20modern%20aesthetic&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '理性吃瓜人',
    time: '12小时前',
    content: '最欣赏这个网站的一点是会标注信息来源，不是那种乱编故事的营销号。吃瓜也要讲究真实性，这点做得很到位。',
    likes: 145,
  },
  {
    id: 'cmt-5',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20avatar%20portrait%20in%20warm%20gold%20tones%2C%20digital%20art%20style%2C%20simple%20clean%20background%2C%20modern%20aesthetic&width=80&height=80&seq=avatar-05&orientation=squarish',
    name: '追瓜一线',
    time: '1天前',
    content: '手机版体验超级流畅！坐地铁的时候刷刷吃瓜视频，通勤时间过得飞快。建议出一个夜间模式，这样晚上在被窝里刷更舒服哈哈。',
    likes: 112,
  },
];

export const cardItems = [
  {
    id: 'card-1',
    title: '本周最火网红爆料：直播间意外曝光私人聊天记录',
    description: '某百万粉丝网红在直播过程中不慎展示了私人聊天界面，引发网友对其中内容的疯狂解读和讨论。',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20illustration%20of%20live%20streaming%20drama%20with%20chat%20messages%2C%20warm%20coral%20and%20soft%20amber%20tones%2C%20digital%20art%20style%2C%20dynamic%20composition%20with%20geometric%20chat%20bubble%20elements&width=400&height=300&seq=card-01&orientation=landscape',
    tag: '网红爆料',
    date: '2026-07-28',
  },
  {
    id: 'card-2',
    title: '娱乐圈年度最大反转：知名艺人深夜发长文回应争议',
    description: '沉寂数月后，该艺人通过社交平台发布千字长文，详细回应了近期的各种传闻，引发新一轮热议。',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20illustration%20of%20celebrity%20news%20and%20social%20media%20post%2C%20warm%20terracotta%20and%20gold%20color%20scheme%2C%20digital%20art%20aesthetic%2C%20elegant%20geometric%20composition&width=400&height=300&seq=card-02&orientation=landscape',
    tag: '明星动态',
    date: '2026-07-27',
  },
  {
    id: 'card-3',
    title: '热门综艺录制现场突发状况，全场嘉宾表情管理失败',
    description: '某综艺最新一期录制中发生了意料之外的事件，多位嘉宾的真实反应被镜头完整记录下来。',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20digital%20illustration%20of%20variety%20show%20recording%20moment%2C%20warm%20amber%20and%20coral%20palette%2C%20playful%20geometric%20shapes%2C%20modern%20minimalist%20style&width=400&height=300&seq=card-03&orientation=landscape',
    tag: '综艺名场面',
    date: '2026-07-27',
  },
  {
    id: 'card-4',
    title: '社交媒体热搜榜被这条爆料刷屏，阅读量破5亿',
    description: '一条普通用户的爆料帖在短短几小时内引爆全网讨论，各路大V纷纷转发评论，热度持续攀升。',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20illustration%20of%20viral%20social%20media%20trending%20topic%2C%20warm%20coral%20and%20soft%20gold%20tones%2C%20digital%20art%20style%2C%20dynamic%20geometric%20wave%20patterns&width=400&height=300&seq=card-04&orientation=landscape',
    tag: '热搜事件',
    date: '2026-07-26',
  },
  {
    id: 'card-5',
    title: '独家整理：下半年最值得期待的十大综艺节目前瞻',
    description: '为你盘点下半年即将上线的热门综艺节目，从嘉宾阵容到节目模式，提前带你了解吃瓜新方向。',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20illustration%20of%20upcoming%20entertainment%20shows%20preview%2C%20warm%20terracotta%20and%20amber%20color%20scheme%2C%20digital%20art%20style%2C%20clean%20geometric%20grid%20composition&width=400&height=300&seq=card-05&orientation=landscape',
    tag: '前瞻盘点',
    date: '2026-07-26',
  },
];

export const updateItems = [
  {
    id: 'upd-1', time: '10:32', date: '07-29',
    title: '某流量明星被拍到深夜与神秘人同返公寓，粉丝集体破防',
    type: 'hot',
  },
  {
    id: 'upd-2', time: '09:15', date: '07-29',
    title: '知名网红直播带货翻车，产品实际效果与宣传严重不符',
    type: 'new',
  },
  {
    id: 'upd-3', time: '08:00', date: '07-29',
    title: '新一季选秀节目导师阵容官宣，三位大咖确认加盟',
    type: 'new',
  },
  {
    id: 'upd-4', time: '23:45', date: '07-28',
    title: '某综艺节目录制期间嘉宾突发身体不适，节目组紧急叫停',
    type: 'hot',
  },
  {
    id: 'upd-5', time: '21:30', date: '07-28',
    title: '社交媒体疯传某艺人合约到期将签约新公司的消息',
    type: 'hot',
  },
  {
    id: 'upd-6', time: '18:20', date: '07-28',
    title: '年度最具争议广告片引发网友两极分化评论',
    type: 'new',
  },
  {
    id: 'upd-7', time: '15:10', date: '07-28',
    title: '娱乐圈资深经纪人罕见发声，揭露行业幕后操作',
    type: 'new',
  },
  {
    id: 'upd-8', time: '11:05', date: '07-28',
    title: '某短视频平台头部博主被指抄袭，原创作者发声维权',
    type: 'hot',
  },
  {
    id: 'upd-9', time: '08:40', date: '07-28',
    title: '热播剧集大结局引发观众不满，导演亲自回应争议',
    type: 'new',
  },
];

export const topicItems = [
  { id: 'topic-1', name: '网红翻车', heat: 98500, trend: 'up' },
  { id: 'topic-2', name: '明星恋情', heat: 87200, trend: 'up' },
  { id: 'topic-3', name: '综艺名场面', heat: 76400, trend: 'up' },
  { id: 'topic-4', name: '直播爆料', heat: 69300, trend: 'hot' },
  { id: 'topic-5', name: '微博热搜', heat: 65100, trend: 'up' },
  { id: 'topic-6', name: '影视吐槽', heat: 58800, trend: 'stable' },
  { id: 'topic-7', name: '时尚翻车', heat: 51200, trend: 'down' },
  { id: 'topic-8', name: '体育八卦', heat: 47900, trend: 'up' },
  { id: 'topic-9', name: '游戏圈大瓜', heat: 43500, trend: 'hot' },
  { id: 'topic-10', name: '音乐圈爆料', heat: 39800, trend: 'stable' },
  { id: 'topic-11', name: '跨国八卦', heat: 35200, trend: 'up' },
];

export const rankingItems = [
  { id: 'rank-1', rank: 1, title: '某顶流被曝隐婚生子，知情人透露更多细节', views: '1280万', trend: 'up' },
  { id: 'rank-2', rank: 2, title: '综艺录制现场嘉宾互怼完整视频流出', views: '1056万', trend: 'up' },
  { id: 'rank-3', rank: 3, title: '网红直播间意外连麦前男友，尴尬场面全网疯传', views: '987万', trend: 'hot' },
  { id: 'rank-4', rank: 4, title: '知名导演新片选角内幕曝光，多位演员回应', views: '892万', trend: 'up' },
  { id: 'rank-5', rank: 5, title: '某品牌代言人风波持续发酵，品牌方紧急发声明', views: '765万', trend: 'down' },
  { id: 'rank-6', rank: 6, title: '热播剧原著作者发文吐槽改编，剧方连夜回应', views: '698万', trend: 'stable' },
  { id: 'rank-7', rank: 7, title: '年度音乐颁奖礼提名引争议，多位歌手粉丝互撕', views: '621万', trend: 'up' },
];

export const featureItems = [
  {
    id: 'feat-1',
    icon: 'ri-flashlight-line',
    title: '极速更新',
    description: '7×24小时不间断追踪全网热点，大瓜发生后的第一时间整理推送，让你永远走在吃瓜第一线。',
  },
  {
    id: 'feat-2',
    icon: 'ri-stack-line',
    title: '海量合集',
    description: '覆盖网红爆料、明星动态、综艺名场面、社交热议等全品类吃瓜内容，每日更新海量视频资源。',
  },
  {
    id: 'feat-3',
    icon: 'ri-shield-check-line',
    title: '真实可靠',
    description: '严格标注信息来源，多方核实重要爆料内容，拒绝虚假信息和恶意造谣，做负责任的吃瓜平台。',
  },
];

export const mediaItems = [
  {
    id: 'media-1',
    title: '网红直播翻车名场面合集：那些年我们吃过的最大瓜',
    duration: '15:28',
    views: '328万',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20video%20thumbnail%20illustration%20of%20internet%20influencer%20live%20streaming%20drama%20compilation%2C%20warm%20coral%20and%20amber%20palette%2C%20digital%20art%20style%2C%20modern%20geometric%20play%20button%20design&width=400&height=250&seq=media-01&orientation=landscape',
    tag: '网红翻车',
  },
  {
    id: 'media-2',
    title: '娱乐圈年度十大争议事件完整回顾',
    duration: '22:15',
    views: '256万',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20video%20thumbnail%20illustration%20of%20entertainment%20year%20review%20controversies%2C%20warm%20terracotta%20and%20gold%20tones%2C%20digital%20art%20aesthetic%2C%20clean%20geometric%20timeline%20design&width=400&height=250&seq=media-02&orientation=landscape',
    tag: '年度盘点',
  },
  {
    id: 'media-3',
    title: '综艺节目最尴尬瞬间TOP20：隔着屏幕都替他们抠地',
    duration: '18:42',
    views: '412万',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20video%20thumbnail%20of%20variety%20show%20awkward%20moments%20compilation%2C%20warm%20amber%20and%20coral%20color%20scheme%2C%20dynamic%20geometric%20shapes%2C%20playful%20modern%20design&width=400&height=250&seq=media-03&orientation=landscape',
    tag: '综艺名场面',
  },
  {
    id: 'media-4',
    title: '明星私服穿搭翻车大赏：原来他们也有审美不在线的时候',
    duration: '12:56',
    views: '189万',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20illustration%20of%20celebrity%20fashion%20fails%20compilation%2C%20warm%20coral%20and%20soft%20gold%20tones%2C%20digital%20art%20style%2C%20elegant%20geometric%20fashion%20elements&width=400&height=250&seq=media-04&orientation=landscape',
    tag: '时尚八卦',
  },
  {
    id: 'media-5',
    title: '社交媒体年度热搜Top50事件全记录',
    duration: '35:10',
    views: '534万',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20video%20thumbnail%20of%20social%20media%20trending%20topics%20compilation%2C%20warm%20terracotta%20and%20amber%20palette%2C%20digital%20art%20aesthetic%2C%20dynamic%20geometric%20chart%20design&width=400&height=250&seq=media-05&orientation=landscape',
    tag: '年度热搜',
  },
];